<template>
    <div class="mb-3 ml-12">
        <nav class="sm:hidden ">
            <a
                href="#"
                class="flex items-center text-sm font-medium leading-5 text-gray-500 transition duration-150 ease-in-out hover:text-gray-700 focus:outline-none focus:underline"
            >
                <svg
                    class="flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path
                        fill-rule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                    />
                </svg>
                Back
            </a>
        </nav>
        <nav class="items-center hidden text-sm font-medium leading-5 sm:flex">
            <fragment v-for="(route, index) in pervRoute" :key="index">
                <a
                    href="#"
                    class="text-blue-600 transition duration-150 ease-in-out hover:text-gray-800 focus:outline-none focus:underline"
                    >{{ route }}</a
                >
                <svg
                    class="flex-shrink-0 w-5 h-5 mx-2 text-gray-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path
                        fill-rule="evenodd"
                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                        clip-rule="evenodd"
                    />
                </svg>
            </fragment>
            <a
                href="#"
                class="font-bold text-blue-600 transition duration-150 ease-in-out hover:text-blue-800 focus:outline-none focus:underline"
            >
                {{ activeRoute }}</a
            >
        </nav>
    </div>
</template>

<script>
export default {
    computed: {
        activeRoute() {
            return this.$route.meta.steps[this.$route.meta.steps["length"] - 1];
        },
        pervRoute() {
            let route = [];
            for (
                let index = 0;
                index < this.$route.meta.steps.length - 1;
                index++
            ) {
                route.push(this.$route.meta.steps[index]);
            }
            return route;
        }
    }
};
</script>


